import { render, staticRenderFns } from "./ContributionsGraphWidget.vue?vue&type=template&id=54169772&scoped=true"
import script from "./ContributionsGraphWidget.vue?vue&type=script&lang=ts"
export * from "./ContributionsGraphWidget.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsGraphWidget.vue?vue&type=style&index=0&id=54169772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54169772",
  null
  
)

export default component.exports